// Lightweight global toast system. Any module can call showToast(); a
// single <Toast> component mounted at the app root listens for the events
// and renders them. Avoids prop drilling and React context for what is
// fundamentally a side-effect.

const EVENT_NAME = 'myhr-toast';

export function showToast(message, kind = 'info') {
  if (typeof window === 'undefined') return;
  // Normalize: callers may pass an Error or arbitrary object — render
  // something readable rather than [object Object].
  const text = typeof message === 'string'
    ? message
    : (message?.message ?? String(message));
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { message: text, kind } }));
}

export const showError = msg => showToast(msg, 'error');
export const showInfo = msg => showToast(msg, 'info');

export function subscribe(handler) {
  if (typeof window === 'undefined') return () => {};
  // Defend against unexpected dispatchers — default detail to {} and
  // skip the call entirely if there's no message after normalization.
  const listener = e => {
    const detail = (e && typeof e.detail === 'object' && e.detail !== null) ? e.detail : {};
    if (!detail.message) return;
    handler(detail);
  };
  window.addEventListener(EVENT_NAME, listener);
  return () => window.removeEventListener(EVENT_NAME, listener);
}
